import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { BllStoklar } from './../../../providers/bll/bll-stoklar';
import { BllViewStoklar } from './../../../providers/bll/bll-ViewStoklar';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Searchbar } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';


@Component({
  selector: 'page-hizli-fiyat-degistir',
  templateUrl: 'hizli-fiyat-degistir.html',
})
export class HizliFiyatDegistirPage {
  aranan = "";
  
  stoklistesi = [];
  stokadi = "";
  fiyatlar: any = { ID:"",Price: "", Price2: "", Price3: "", Price4: "",StokAdi:"" }
  gelenStok: any = { ID:"",Price: "", Price2: "", Price3: "", Price4: "",StokAdi:"" }
  yenifiyat: number = 0;
  @ViewChild('searchbar') searchbar: Searchbar;
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public viewCtrl: ViewController,
    public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.searchbar.setFocus();
  }
  ionViewDidEnter() {
    setTimeout(() => {
      this.searchbar.setFocus();
    });
  }

  UrunAraDB()
  {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    console.log("ara1",this.aranan);
    this.bllOrtak.islem(formData, "StokBulBarkod", "", false).then(a => {
      var sonuc = <any>a;
      this.stoklistesi = sonuc.SonucObject;
 

 console.log("ss",this.stoklistesi)
 console.log("aranan",this.aranan)
 
if (this.stoklistesi.length == 1) {
  this.gelenStok=sonuc.SonucObject;
  this.stoklistesi.forEach(e => {
    this.fiyatlar.Price1 = e.Price1;
    this.fiyatlar.Price2 = e.Price2;
    this.fiyatlar.Price3 = e.Price3;
    this.fiyatlar.Price4 = e.Price4;
    this.stokadi = e.StokAdi;
    this.fiyatlar.ID=e.ID;
 
    this.searchbar.setFocus();
  })
}

if (this.stoklistesi.length == 0){
  this.stoklistesi =[];
  this.gelenStok=[];

      this.fiyatlar.Price1 = 0;

      this.fiyatlar.Price2 = 0;
      this.fiyatlar.Price3 =0;
      this.fiyatlar.Price4 = 0;
      this.stokadi ="";
      this.fiyatlar.ID=-1;
      this.searchbar.setFocus();
}
})



 
}
  urunAra() {
    console.log("ara1",this.aranan);
    var bllstok = new BllStoklar();
    bllstok.getAllWithSpecificQuery("(Barcode1='" + this.aranan + "')").then(a => {
      this.stoklistesi = a;
      if (this.stoklistesi.length == 1) {
        this.stoklistesi.forEach(e => {
          this.fiyatlar.Price1 = e.Price1;
          this.fiyatlar.Price2 = e.Price2;
          this.fiyatlar.Price3 = e.Price3;
          this.fiyatlar.Price4 = e.Price4;
          this.stokadi = e.StokAdi;
          this.fiyatlar.ID=e.ID;
          this.searchbar.setFocus();

        })
      }
    });
  }
  urunler(e) {
    if (e.keyCode == 13) {
      this.UrunAraDB();
    }
  }

  Kaydet() {
    var stok = new BllStoklar();
    stok.FiyatlariGuncelle(this.fiyatlar).then(a => {

    });
    var stokview=new BllViewStoklar();
    stokview.FiyatlariGuncelle(this.fiyatlar).then(a=>{

    });
    var formdata=new FormData();
    console.log("ff",this.fiyatlar)
    formdata.append("Stok_json",JSON.stringify(this.fiyatlar));
    this.bllOrtak.islem(formdata,"HizliFiyatDegistir","Lütfen Bekleyiniz",true).then(a=>{
      var sonuc=<any>a;
      if(sonuc.Sonuc==1)
      {
        this.ortak.showBasicAlert("Başarılı","Fiyatlar başarı bir şekilde değiştirildi");
        this.viewCtrl.dismiss();
        this.searchbar.setFocus();
      }
      if(sonuc.Sonuc!=1)
      {
        this.ortak.showBasicAlert("Hata","Beklenmedik bir hata oluştu");
        this.searchbar.setFocus();
      }
    })
  }
  Kapat() {
    this.viewCtrl.dismiss();
  }







}



// WEBPACK FOOTER //
// ./src/pages/PerakendeIslemleri/hizli-fiyat-degistir/hizli-fiyat-degistir.ts